/**
 * Analytics event names used across all platforms and tenants.
 */
export const AnalyticsEventName = {
    SESSION_START: "session_start",
    REGISTRATION_ELIGIBILITY_CHECK_COMPLETED:
        "registration_eligibility_check_completed",
    REGISTRATION_EMAIL_SENT: "registration_email_sent",
    LOGIN_BY_SMS_COMPLETED: "login_by_sms_completed",
    LOGIN_BY_SMS_ATTEMPTED: "login_by_sms_attempted",
    LOGIN_BY_EMAIL_COMPLETED: "login_by_email_completed",
    LOGIN_BY_EMAIL_ATTEMPTED: "login_by_email_attempted",
    LOGIN_SWITCHED_TO_EMAIL_AFTER_SMS: "login_switched_to_email_after_sms",
    ONBOARDING_STEP_COMPLETED: "onboarding_step_completed",
    VIEW_DISCOVER_OPENED: "view_discover_opened",
    VIEW_CONCIERGE_OPENED: "view_concierge_opened",
    VIEW_BOOKINGS_OPENED: "view_bookings_opened",
    VIEW_CONVERSATIONS_OPENED: "view_conversations_opened",
    VIEW_PROFILE_OPENED: "view_profile_opened",
    VIEW_PROPOSAL_OPENED: "view_proposal_opened",
    REQUEST_TO_BOOK: "request_to_book",
    BOOKING_OPENED: "booking_opened",
    CHAT_OPENED: "chat_opened",
    CHAT_GENERAL_OPENED: "chat_general_opened",
    CHAT_THREAD_OPENED: "chat_thread_opened",
    CHAT_REACTION_SENT: "chat_reaction_sent",
    CHAT_REPLY_SENT: "chat_reply_sent",
    CHAT_MESSAGE_COPIED: "chat_message_copied",
    CHAT_AUDIO_MESSAGE_SENT: "chat_audio_message_sent",
    CHAT_OFFLINE_STATE_SHOWN: "chat_offline_state_shown",
    CHAT_NOTIFICATION_BANNER_SHOWN: "chat_notification_banner_shown",
    CHAT_AUDIO_TRANSCRIPTION_SHOWN: "chat_audio_transcription_shown",
    ARTICLE_OPENED: "article_opened",
    CATEGORY_OPENED: "category_opened",
    REQUEST_RECOMMENDATIONS_TRIGGERED: "request_recommendations_triggered",
    REQUEST_RECOMMENDATIONS_READY: "request_recommendations_ready",
    REQUEST_RECOMMENDATIONS_FAILED: "request_recommendations_failed",
    REQUEST_RECOMMENDATIONS_OPTION_ADDED: "request_recommendations_option_added",
    REQUEST_FIRST_OPTION_ADDED: "request_first_option_added",
    REQUEST_RECOMMENDATIONS_REGENERATED: "request_recommendations_regenerated",
    REQUEST_CAPTURE_COMPLETED: "request_capture_completed",
    REQUEST_CAPTURE_FAILED: "request_capture_failed",
    REQUEST_BRIEF_COMPLETED: "request_brief_completed",
    REQUEST_BRIEF_FAILED: "request_brief_failed",
    REQUEST_FIELD_EDITED_AFTER_AI: "request_field_edited_after_ai",
    PAYMENT_REQUESTED: "payment_requested",
    INVOICE_CREATED: "invoice_created",
    INVOICE_PAID: "invoice_paid",
    RECEIPT_ATTACHED_TO_BOOKING: "receipt_attached_to_booking",
    NATIVE_AUTH_MIGRATION_TRIGGERED: "native_auth_migration_triggered",
} as const;

export type AnalyticsEventName =
    (typeof AnalyticsEventName)[keyof typeof AnalyticsEventName];

/**
 * Type alias for AnalyticsEventName (for backward compatibility)
 */
export type AnalyticsEventNameType = AnalyticsEventName;

/**
 * Client types that can send analytics events.
 */
export type AnalyticsClientType = "ios" | "android" | "lmt" | "concierge";

/**
 * Raw data that can be attached to analytics events.
 * This is a flexible JSON object that can contain any custom properties.
 */
export type RawData = Record<string, unknown> | undefined;
